export const APP_ACCESS_BLOCKED = 'APP_ACCESS_BLOCKED';
export const EMPLOYEE_OVER_LIMIT = 'EMPLOYEE_OVER_LIMIT';
export const AUTH_REQUIRED = 'AUTH_REQUIRED';

export interface ApiErrorBody {
  errorCode?: string;
  messageKey?: string;
  message?: string;
  debugMessage?: string;
}

export function readApiErrorCode(error: unknown): string | undefined {
  if (!error || typeof error !== 'object') {
    return undefined;
  }
  const body = (error as { error?: ApiErrorBody }).error;
  return body?.errorCode;
}
